import React, { useState } from "react";

import { getContactLink, goTo, useAppType, useNavigate, useTranslation, useUserContext } from "utils";

import { appVersions } from "enums";

import { Avatar, AvatarImage, Drawer, Icon, IconLinkButton, Link, Typography } from "components";

export const NavDrawer = ({ visible, onClose }) => {
  const { t } = useTranslation("nav");
  const { user } = useUserContext();

  const appType = useAppType();
  const navigate = useNavigate();

  const [year] = useState(new Date().getFullYear());

  const marginTop = !appType.desktop ? "margin-top-250" : "margin-top-300";
  return (
    <Drawer
      dataTestId="nav-drawer"
      className="nav-drawer"
      isNavDrawer
      title=""
      visible={visible}
      wide={appType.mobile}
      onClose={onClose}
      logoUrl={"/dashboard"}
    >
      <>
        {/* Profile */}
        <div className="drawer-row">
          <div>
            {user && user.image && user.image !== "false" ? (
              <AvatarImage image={user.image} size="m" onClick={() => goTo(null, navigate, "/user")} />
            ) : (
              <Avatar size="m" name={`${user.firstName} ${user.lastName}`} onClick={() => goTo(null, navigate, "/user")} />
            )}
          </div>
          <div>
            <Typography variant="h2" onClick={() => goTo(null, navigate, "/user")} className="pointer">{`${user.firstName} ${user.lastName}`}</Typography>
            <Link to={"/user"} onClick={onClose}>
              {t("drawer.viewProfile")}
            </Link>
          </div>
        </div>

        {/* Navigation links */}
        <div className={`drawer-col ${marginTop}`}>
          <div className="drawer-row with-icon pointer">
            <Icon iconName="tabler/file" />
          </div>
          <div className="drawer-row with-icon pointer">
            <Icon iconName="tabler/settings" />
            <Link to="/user/settings" onClick={onClose} mixpanelText={t("drawer.settings")}>
              <Typography variant="h3">{t("drawer.settings")}</Typography>
            </Link>
          </div>
        </div>

        {/* Support */}
        <div className={`do-you-need-help ${marginTop}`}>
          <div className="padding-100">
            <Typography variant="paragraph-m" color="grey-600" className="inline">
              {t("drawer.needHelp")}
            </Typography>
            <div className="drawer-col">
              <div className="drawer-row with-icon pointer">
                <Icon iconName="tabler/mail" />
                <Typography variant="h6" onClick={() => goTo(null, null, getContactLink(), true)}>
                  {t("drawer.contactUs")}
                </Typography>
              </div>
            </div>
          </div>
        </div>

        <div className={`${marginTop}`}>
          <IconLinkButton
            dataTestId="logout-button"
            iconType="logout"
            text={t("drawer.logout")}
            href="/sign-out"
            onClick={() => {
              onClose();
            }}
          />
        </div>

        <div className={marginTop}>
          <Typography variant="paragraph-m" style={{ color: "#999999", fontSize: "12px" }}>
            &#169; {year} Klim GmbH · v{appVersions[0].major}.{appVersions[0].minor}
          </Typography>
        </div>
      </>
    </Drawer>
  );
};

export default NavDrawer;
